const KEY = "cvtrg_my_request_ids_v1";

export function addMyRequest(id) {
  try {
    const raw = localStorage.getItem(KEY);
    const set = new Set(raw ? JSON.parse(raw) : []);
    set.add(id);
    localStorage.setItem(KEY, JSON.stringify([...set]));
  } catch (error) {
    console.error("Erreur lors de l'ajout de la demande personnelle:", error);
  }
}

export function isMyRequest(id) {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) && arr.includes(id);
  } catch (error) {
    console.error(
      "Erreur lors de la vérification de la demande personnelle:",
      error,
    );
    return false;
  }
}

export function removeMyRequest(id) {
  try {
    const raw = localStorage.getItem(KEY);
    const set = new Set(raw ? JSON.parse(raw) : []);
    set.delete(id);
    localStorage.setItem(KEY, JSON.stringify([...set]));
  } catch (error) {
    console.error(
      "Erreur lors de la suppression de la demande personnelle:",
      error,
    );
  }
}
